// Global Instructions Rule Applied!
import React from 'react'

/**
 * Reusable component for displaying formatted dates as badges
 * @param {object} props
 * @param {string|Date} props.date - The date value to format and display
 * @param {'default'|'compact'} [props.size] - Size variant
 * @param {string} [props.textSize] - Text size, e.g. '8px'
 */
const LabelDateBadge = ({ date, size = 'default', textSize = '10px', ...props }) => {
  if (!date) {
    return null
  }

  // Format the date to MM/DD format
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit'
  })

  return (
    <div
      style={{
        fontSize: textSize,
        paddingLeft: size === 'default' ? 2 : 1,
        paddingRight: size === 'default' ? 2 : 1,
        paddingTop: size === 'default' ? 2 : 1,
        paddingBottom: size === 'default' ? 2 : 1
      }}
      className={`bg-blue-100 text-blue-600 border border-blue-300 py-${size === 'default' ? '0.5' : '0.4'} h-${size === 'default' ? '5' : '3.5'} rounded-md font-medium flex items-center justify-center`}
    >
      {formattedDate}
    </div>
  )
}

export default LabelDateBadge
